export default [{
      stateName: "priority",
      type: "Dropdown",
      required: false,
      name: "الأولوية / Priority",
      options: [{
            "id": "normal",
            "value": "عادي / Normal"
         },
         {
            "id": "urgent",
            "value": "طارئ / Urgent"
         },
         {
            "id": "top_urgent",
            "value": "طارئ جدا / Top Urgent"
         },
      ]
   },
   {
      name: "Due Date",
      stateName: "dueDate",
      type: "TextInputDueDate",
      required: false,
   }
]

export let staffsDropdown = {
   name: "Redirect to - إعادة توجيه إلى",
   stateName: "directedStaffs",
   type: "Dropdown2",
   required: false,
   isClearable: true,
   isMulti: true,
}